/* src/app/global/components/global-help/global-help-buttons/global-help-buttons.component.scss */
:host mat-button-toggle-group {
  border: none;
  border-radius: 0;
  height: 44px;
  width: 100%;
}
:host .mat-button-toggle {
  align-items: center;
  background: var(--color-primary);
  color: var(--color-default-light);
  display: flex;
  font-size: 1.5rem;
  height: 100%;
  width: 100%;
}
:host ::ng-deep .mat-button-toggle-button {
  height: 100%;
}
:host .mat-button-toggle-checked {
  background: var(--color-accent);
}
:host ::ng-deep .mat-button-toggle .mat-button-toggle-label-content {
  line-height: 1;
}
:host ::ng-deep .mat-button-toggle-checked .mat-button-toggle-focus-overlay {
  border: none;
}
/*# sourceMappingURL=global-help-buttons.component.css.map */
